import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import {
  ROUTE_WATCHLIST,
  ROUTE_WATCHLIST_WITH_EVENTS,
} from '@/constants/routes';
import { redirect } from 'redux-first-router';
import loadable from '@loadable/component';
const Events = loadable(() => import('@/components/Events'), {
  resolveComponent: (components) => components.Events,
});

/**
 *
 * This component only renders when
 * the current route is ROUTE_WATCHLIST_WITH_EVENTS
 * **/
export function EventsModal() {
  const dispatch = useDispatch();
  const eventId = useSelector<any, string | undefined>((state) => {
    if (state.location.type === ROUTE_WATCHLIST_WITH_EVENTS) {
      return state.location.payload.eventId;
    }
  }, shallowEqual);
  const handleClose = () => {
    dispatch(redirect({ type: ROUTE_WATCHLIST }));
  };
  if (typeof eventId === 'undefined') {
    return null;
  }
  return <Events eventsId={eventId} onClose={handleClose} />;
}
